import {
  IDownloadRemittanceDocumentsParams,
  IDownloadRemittanceDocumentsRepositoryResponse,
  IRemittanceRepository,
} from "@/core/repositories/remittance";

export class ExportRemittanceDocumentsUseCase {
  constructor(private readonly remittanceRepository: IRemittanceRepository) {}

  async execute(params: IDownloadRemittanceDocumentsParams, formats: { date?: string; number?: string }): Promise<IDownloadRemittanceDocumentsRepositoryResponse> {
    return this.remittanceRepository.downloadRemittanceDocuments(params, formats);
  }
}
